<div *ngIf="exibirBarraCor" style="background-color: rgb(0, 152, 223); height: 5px;"></div>
<div class="botoes-filtros">
  <div class="float-left">
    <button translate type="button" class="btn mr-1" [class.btn-info]="!listagemComFiltros"
      *ngIf="exibirBotaoDefinirFiltros" [class.btn-warning]="listagemComFiltros" (click)="definirFiltragem();">
      {{'barraConsulta.definirFiltros'}}
      <em class="fa fa-filter"></em>
    </button>
    <button translate id="buscarDados" type="button" class="btn btn-secondary mr-1" (click)="buscarRegistros();"
      *ngIf="exibirBotaoBuscar">
      {{'barraConsulta.buscarDados'}}
      <em class="fa fa-search"></em>
    </button> {{bloquearBotaoNovoCadastro}}
  </div>
  <div class="float-right">
    <button *ngIf="detalhe" type="button" class="btn btn-info mr-1" (click)="detalhe.acao()">
      <em [ngClass]="detalhe.icone" class="fa fa-calendar" aria-hidden="true"></em>
      {{detalhe.descricao | translate}}
    </button>
    <button translate type="button" *ngIf="exibirNovo" class="btn btn-primary mr-1" (click)="criar();">
      <em class="fa fa-plus"></em>
      {{'barraConsulta.novo'}}
    </button>

    <a translate class="btn btn-outline-info" *ngIf="exibirBotaoAjuda"
      href="http://ajuda.nbsi.com.br:84/index.php/Solu%C3%A7%C3%B5es_Web_-_Portal_NBS" target="_blank">
      {{'barraConsulta.ajuda'}}
      <em class="fa fa-question"></em>
    </a>
  </div>
  <div class="clear"></div>
</div>